import type { ReactNode } from 'react';

export interface TabViewPanelHeaderTemplateOptions {
  className: string;
  selected: boolean;
}

export interface TabViewPanelProps {
  header: string | React.JSX.Element;
  disabled?: boolean;
  panelStyles?: string;
  /**
   * Optional custom header renderer. When provided it fully replaces the default tab anchor,
   * letting consumers render e.g. a router `<Link>`. Omit to keep the default header.
   */
  headerTemplate?: (options: TabViewPanelHeaderTemplateOptions) => ReactNode;
  children: ReactNode;
}

export default function TabViewPanel({ panelStyles, children }: TabViewPanelProps) {
  return <div className={panelStyles}>{children}</div>;
}
